import { useCallback } from "react";
import {
  ButtonToVisible,
  VendorAssessmentButtonToVisible,
  WorkflowTransitions,
} from "@/context/data.types";
import { TRANSITION_RULES, CUSTOM_RULES } from "@/utils/vendor/workflowButtonRules";
export interface ButtonVisibilityConfig<T extends Record<string, boolean>> {
  type: string;
  defaultVisibility: ButtonToVisible | VendorAssessmentButtonToVisible | T;
}

type retrieveButtonsStatusesType = {
  status?: string;
  workflowStatus?: string[];
  workflowTransitions: WorkflowTransitions[];
};
interface retrieveButtonsTypes {
  statuses: retrieveButtonsStatusesType;
  showVendorInfoForm?: boolean;
}

const useWorkflowButtonVisibility = <T extends Record<string, boolean>>({
  type,
  defaultVisibility,
}: ButtonVisibilityConfig<T>) => {
  const retrieveButtons = useCallback(
    ({ statuses, showVendorInfoForm }: retrieveButtonsTypes): any => {
      let visibility = { ...defaultVisibility };
      if (TRANSITION_RULES[type as keyof typeof TRANSITION_RULES]) {
        type Visibility = Record<string, boolean>;

        const labelsCI = new Set(
          (statuses?.workflowTransitions ?? []).map(o => o.label.toLowerCase())
        );
        const resultCI = TRANSITION_RULES[type as keyof typeof TRANSITION_RULES].filter(o =>
          labelsCI.has(o.label.toLowerCase())
        );

        const ruleVisibility = resultCI.reduce<Partial<Visibility>>((acc, item) => {
          for (const [key, val] of Object.entries(item.visibility)) {
            acc[key as keyof Visibility] = Boolean(acc[key as keyof Visibility]) || Boolean(val);
          }
          return acc;
        }, {});

        let updatedVisibility: Visibility = {
          ...defaultVisibility,
          ...ruleVisibility,
        };

        switch (type) {
          case "CREATE_PRODUCT":
            updatedVisibility = CUSTOM_RULES?.[type](
              statuses.status,
              updatedVisibility,
              showVendorInfoForm
            );
            break;
          case "VENDOR_ASSESSMENT":
            updatedVisibility = CUSTOM_RULES?.[type](statuses.status, updatedVisibility);
            break;
          case "VENDOR_ASSESSMENT_FORM_TABS":
            updatedVisibility = CUSTOM_RULES?.[type](
              statuses.status,
              updatedVisibility,
              statuses?.workflowStatus?.[0] || ""
            );
            break;
          case "BUSINESS_QUESTIONAIRE":
            updatedVisibility = CUSTOM_RULES?.[type](
              statuses.status,
              updatedVisibility,
              statuses.workflowTransitions
            );
            break;
          case "TASTING_PANEL":
            updatedVisibility = CUSTOM_RULES?.[type](
              statuses.status,
              updatedVisibility,
              statuses.workflowTransitions
            );
            break;
        }
        return updatedVisibility;
      }

      return visibility;
    },
    []
  );

  return retrieveButtons;
};

export default useWorkflowButtonVisibility;
